import SystemProperty from "../properties/SystemProperty";

// Define the possible environment types
type Environment = 'local' | 'qa' | 'prod' | 'dev' | 'stage' | 'performance';

/**
 * Determines if a message should be displayed based on the environment and display flag.
 * 
 * @param {string} textEnvironment - The environment to check (e.g., 'local', 'qa', 'prod').
 * @param {string} displayMessage - The flag indicating if the message should be displayed.
 * @returns {boolean} - True if the message should be displayed, false otherwise.
 */
export const shouldDisplayMessage = (textEnvironment: string, displayMessage: string): boolean => {
    if (displayMessage !== "true") return false;

    const env = textEnvironment as Environment;
    const methodName = `is${env.charAt(0).toUpperCase() + env.slice(1)}` as keyof typeof SystemProperty;
    const method = SystemProperty[methodName];

    return typeof method === 'function' ? method(textEnvironment) : false;
};